module.exports = __webpack_public_path__ + "img/AI_19.5379634c.png";